import { useEffect, useRef } from 'preact/hooks';
import { cAF, rAF } from '../../raf';
import { TimeUpdate } from '../../types';

export function useManualDuration(
  isPlaying: boolean,
  duration: number,
  updateTimeFn: (timeUpdate: TimeUpdate) => void
) {
  const rAFRef = useRef(-1);
  const startTime = useRef(Date.now());
  const elapsedTime = useRef(0);

  useEffect(() => {
    if (rAFRef.current !== -1) cAF(rAFRef.current);

    if (!isPlaying) {
      elapsedTime.current += Date.now() - startTime.current;

      updateTimeFn({
        duration,
        remainingTime: Math.max(0, duration - elapsedTime.current / 1000),
      });

      return;
    }

    startTime.current = Date.now();
    (function loop() {
      rAFRef.current = rAF(loop);

      const delta = Date.now() - startTime.current;

      updateTimeFn({
        duration,
        remainingTime: Math.max(0, duration - (elapsedTime.current + delta) / 1000),
      });
    })();
  }, [isPlaying]);
}
